<template lang="pug">
  .track-order(ref="root")
    RogueInput(
      label="Order Number"
      :required="true"
      id="increment_id"
      v-model="formData.order"
      @keydown.space.prevent
    )
    RogueInput(
      label="Email"
      :required="true"
      id="email"
      v-model="formData.email"
      type="email"
      @keyup.enter="trackOrder()"
      @keydown.space.prevent
    )
    RogueButton(
      color="black"
      width="full"
      @click="trackOrder()"
      :loading="tracking"
    ) {{ __('Track Order') }}
</template>

<script setup lang="ts">
import { onMounted, reactive, ref, useTemplateRef, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useRogue } from '@/js/services/Rogue'
import { useCustomerStore } from '@/js/stores/customerStore'
import { validate } from '@/js/helpers/validate-fns'
import { messages } from '@/js/app-bridge/messages'

const router = useRouter()
const rogue = useRogue()
const customerStore = useCustomerStore()

const rootElement = useTemplateRef<HTMLDivElement>('root')
const tracking = ref<boolean>(false)
const formData = reactive({
  order : '',
  email : '',
})

watch(() => formData.order, () => {
  const value = removeUnwantedChars(formData.order.toUpperCase())
  formData.order = value
})

watch(() => formData.email, () => {
  const value = removeUnwantedChars(formData.email.toLowerCase())
  formData.email = value
})

onMounted(() => {
  if (rogue.isApp() && customerStore.loggedIn && customerStore.email) {
    formData.email = customerStore.email
  }
})

async function trackOrder(): Promise<void> {
  if (rootElement.value && !validate(rootElement.value)) {
    return
  }

  tracking.value = true
  const { order, email } = formData

  try {
    const { token } = await rogue.fetch<{ token: string }>(`/svc_checkout/order/token`, 'POST', {
      email   : email,
      orderId : order,
    })

    if (!rogue.isApp() || rogue.isApp('3.4.0')) {
      await router.push({ name: 'rss', query: { token: encodeURIComponent(token) } })
    } else {
      rogue.emitToApp(messages.OPEN_IN_WEBVIEW, { url: `/shippingtracker?token=${encodeURIComponent(token)}` })
    }
  } catch (error: any) {
    rogue.log.error('Error retrieving track order token:', { ...error, order, email })
  }
  tracking.value = false
}

function removeUnwantedChars(value: string): string {
  return value.toString().replace(/\s/g, '')
}
</script>
